'use client';

import classNames from 'classnames';

import { IPrice } from 'app/interfaces/prices';
import usePriceStore from './store';
import { useEffect } from 'react';

export default function PriceSwitch({
  items,
  initialId
}: {
  items: IPrice[];
  initialId: string | number | null;
}) {
  const { currentItemId, setCurrentItemId } = usePriceStore();

  useEffect(() => {
    setCurrentItemId(items[0]?.id || null);
  }, [items, setCurrentItemId]);

  // До монтирования (SSR и первый клиентский рендер) стор пуст — берём initialId,
  // чтобы активная кнопка совпадала на сервере и клиенте (без hydration mismatch).
  const activeId = currentItemId ?? initialId;

  return items.map((item, index) => {
    return (
      <button
        type="button"
        key={index}
        onClick={() => setCurrentItemId(item.id)}
        className={classNames('button-default text-white', {
          'border-brown bg-brown': activeId === item.id,
          'border-white-30 hover:border-white': activeId !== item.id
        })}
      >
        {item.name}
      </button>
    );
  });
}
